module.exports = "<p><a href=https://www.mca.com.au/about/media/ >Media Contacts</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/footer/footer_text.md
// module id = 814
// module chunks = 0